import { createQueryKeys } from "@lukemorales/query-key-factory";
import axios from "axios";
import { ConfigurationTemplateApi } from "mws-framethegame-ts-sdk";

const getConfigurationTemplatesApi = () => {
  return new ConfigurationTemplateApi(
    undefined,
    useRuntimeConfig().public.ftgServiceUrl,
    axios,
  );
};

export const presetsQueryKeys = createQueryKeys("presets", {
  list: (productId: MaybeRef<string>) => ({
    queryKey: [productId],
    queryFn: async () => {
      const response = await getConfigurationTemplatesApi().presetsGet({
        frameableProductExternalId: unref(productId),
      });

      return response.data;
    },
  }),
});
